import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBag2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconBag2"><Path d="M16.752 3H7.25195V7H8.75V21H15.25V7H8.75195V4.5H15.252V7H16.75V21H22V7H16.752V3Z" fill="currentColor"/><Path d="M2 7H7.25V21H2V7Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBag2;
